/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export const Collections = {
	Authorigins: "_authOrigins",
	Externalauths: "_externalAuths",
	Mfas: "_mfas",
	Otps: "_otps",
	Superusers: "_superusers",
	AuditLog: "audit_log",
	ConnectedApps: "connected_apps",
	Conversations: "conversations",
	Customers: "customers",
	Invitations: "invitations",
	Invoices: "invoices",
	OauthClients: "oauth_clients",
	PaymentMethods: "payment_methods",
	RecurringInvoices: "recurring_invoices",
	Subscriptions: "subscriptions",
	Users: "users",
	Workspaces: "workspaces",
} as const
export type Collections = typeof Collections[keyof typeof Collections]

// Alias types for improved usability
export type IsoDateString = string
export type IsoAutoDateString = string & { readonly autodate: unique symbol }
export type RecordIdString = string
export type FileNameString = string & { readonly filename: unique symbol }
export type HTMLString = string

type ExpandType<T> = unknown extends T
	? T extends unknown
		? { expand?: unknown }
		: { expand: T }
	: { expand: T }

// System fields
export type BaseSystemFields<T = unknown> = {
	id: RecordIdString
	collectionId: string
	collectionName: Collections
} & ExpandType<T>

export type AuthSystemFields<T = unknown> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AuthoriginsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	fingerprint: string
	id: string
	recordRef: string
	updated: IsoAutoDateString
}

export type ExternalauthsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	provider: string
	providerId: string
	recordRef: string
	updated: IsoAutoDateString
}

export type MfasRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	method: string
	recordRef: string
	updated: IsoAutoDateString
}

export type OtpsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	password: string
	recordRef: string
	sentTo?: string
	updated: IsoAutoDateString
}

export type SuperusersRecord = {
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	id: string
	password: string
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
}

export const AuditLogActionOptions = {
	"finalized": "finalized",
	"status": "status",
	"document": "document",
	"downloaded": "downloaded",
	"credited": "credited",
	"deleted": "deleted",
	"sent": "sent",
	"delivered": "delivered",
	"bounced": "bounced",
	"complaint": "complaint",
	"reminded": "reminded",
	"unlocked": "unlocked",
} as const
export type AuditLogActionOptions = typeof AuditLogActionOptions[keyof typeof AuditLogActionOptions]
export type AuditLogRecord<Tdetail = unknown> = {
	action: AuditLogActionOptions
	created: IsoAutoDateString
	detail?: null | Tdetail
	id: string
	invoice?: RecordIdString
	invoiceNumber?: string
	user?: RecordIdString
	userName?: string
	via?: string
	workspace: RecordIdString
}

export type ConnectedAppsRecord = {
	accessExpiresAt?: IsoDateString
	accessHash?: string
	clientHost?: string
	clientId: string
	clientName?: string
	codeChallenge?: string
	codeExpiresAt?: IsoDateString
	codeHash?: string
	created: IsoAutoDateString
	id: string
	lastUsedAt?: IsoDateString
	redirectUri?: string
	refreshExpiresAt?: IsoDateString
	refreshHash?: string
	scope?: string
	updated: IsoAutoDateString
	user: RecordIdString
	workspace: RecordIdString
}

export type ConversationsRecord<Tmessages = unknown> = {
	created: IsoAutoDateString
	id: string
	messages?: null | Tmessages
	title?: string
	updated: IsoAutoDateString
	user: RecordIdString
}

export const CustomersTypeOptions = {
	"business": "business",
	"private": "private",
} as const
export type CustomersTypeOptions = typeof CustomersTypeOptions[keyof typeof CustomersTypeOptions]

export const CustomersEinvoiceFormatOptions = {
	"pdf": "pdf",
	"zugferd": "zugferd",
	"xrechnung": "xrechnung",
} as const
export type CustomersEinvoiceFormatOptions = typeof CustomersEinvoiceFormatOptions[keyof typeof CustomersEinvoiceFormatOptions]
export type CustomersRecord = {
	addressLine2?: string
	buyerReference?: string
	city?: string
	contactPerson?: string
	country?: string
	created: IsoAutoDateString
	currency?: string
	einvoiceFormat?: CustomersEinvoiceFormatOptions
	email?: string
	firstName?: string
	id: string
	invoiceLanguage?: string
	lastName?: string
	name: string
	noReminders?: boolean
	paymentTermsDays?: string
	phone?: string
	postalCode?: string
	street?: string
	type?: CustomersTypeOptions
	updated: IsoAutoDateString
	vatId?: string
	workspace: RecordIdString
}

export type InvitationsRecord = {
	created: IsoAutoDateString
	email: string
	id: string
	invitedBy?: RecordIdString
	inviterName?: string
	updated: IsoAutoDateString
	workspace: RecordIdString
	workspaceName?: string
}

export const InvoicesAbstractTypeOptions = {
	"invoice": "invoice",
	"template": "template",
	"default": "default",
	"quote": "quote",
} as const
export type InvoicesAbstractTypeOptions = typeof InvoicesAbstractTypeOptions[keyof typeof InvoicesAbstractTypeOptions]

export const InvoicesStatusOptions = {
	"draft": "draft",
	"open": "open",
	"sent": "sent",
	"paid": "paid",
	"overdue": "overdue",
	"cancelled": "cancelled",
	"accepted": "accepted",
	"declined": "declined",
	"expired": "expired",
} as const
export type InvoicesStatusOptions = typeof InvoicesStatusOptions[keyof typeof InvoicesStatusOptions]

export const InvoicesTemplateKindOptions = {
	"invoice": "invoice",
	"quote": "quote",
} as const
export type InvoicesTemplateKindOptions = typeof InvoicesTemplateKindOptions[keyof typeof InvoicesTemplateKindOptions]

export const InvoicesVatModeOptions = {
	"standard": "standard",
	"small_business": "small_business",
	"reverse_charge": "reverse_charge",
	"intra_eu": "intra_eu",
	"export": "export",
	"exempt": "exempt",
} as const
export type InvoicesVatModeOptions = typeof InvoicesVatModeOptions[keyof typeof InvoicesVatModeOptions]

export const InvoicesEinvoiceFormatOptions = {
	"zugferd": "zugferd",
	"xrechnung": "xrechnung",
} as const
export type InvoicesEinvoiceFormatOptions = typeof InvoicesEinvoiceFormatOptions[keyof typeof InvoicesEinvoiceFormatOptions]
export type InvoicesRecord<Tbuyer = unknown, Titems = unknown, TpaymentDetails = unknown, Tsender = unknown> = {
	abstractType: InvoicesAbstractTypeOptions
	accentColor?: string
	autoReminders?: boolean
	buyer?: null | Tbuyer
	companyLogo?: FileNameString
	created: IsoAutoDateString
	creditFor?: RecordIdString
	currency?: string
	currencyFormat?: string
	customer?: RecordIdString
	dateFormat?: string
	discount?: number
	discountLabel?: string
	document?: FileNameString
	documentHash?: string
	documentTitleLabel?: string
	dueDate?: IsoDateString
	dueDateInDays?: number
	dueDateLabel?: string
	einvoice?: FileNameString
	einvoiceFormat?: InvoicesEinvoiceFormatOptions
	emailMessage?: string
	emailSubject?: string
	finalizedAt?: IsoDateString
	finalizedBy?: RecordIdString
	footNoteLeft?: string
	footNoteLeftLabel?: string
	footNoteRight?: string
	footNoteRightLabel?: string
	fromAndToDateLabel?: string
	fromDate?: IsoDateString
	hidePaymentQr?: boolean
	id: string
	invoiceNumber?: string
	invoiceNumberLabel?: string
	invoiceTitle?: string
	issueDate?: IsoDateString
	issueDateLabel?: string
	itemLineTotalLabel?: string
	itemQuantityLabel?: string
	itemTitleLabel?: string
	itemUnitPriceLabel?: string
	items?: null | Titems
	noReminders?: boolean
	paidAt?: IsoDateString
	paymentDetails?: null | TpaymentDetails
	paymentMethod?: RecordIdString
	quoteEmailMessage?: string
	quoteEmailSubject?: string
	quoteValidityDays?: number
	recipientAddressLabel?: string
	recurring?: RecordIdString
	recurringPeriod?: string
	remindedAt?: IsoDateString
	reminderDays1?: number
	reminderDays2?: number
	reminderDays3?: number
	reminderLevel?: number
	sender?: null | Tsender
	senderAddressLabel?: string
	sourceQuote?: RecordIdString
	status: InvoicesStatusOptions
	subTotal?: number
	subTotalLabel?: string
	tax?: number
	taxLabel?: string
	template?: string
	templateKind?: InvoicesTemplateKindOptions
	toDate?: IsoDateString
	total?: number
	totalLabel?: string
	updated: IsoAutoDateString
	vatMode?: InvoicesVatModeOptions
	vatNote?: string
	workspace: RecordIdString
}

export type OauthClientsRecord<TredirectUris = unknown> = {
	clientId: string
	created: IsoAutoDateString
	id: string
	name?: string
	redirectUris?: null | TredirectUris
	updated: IsoAutoDateString
}

export const PaymentMethodsTypeOptions = {
	"bank": "bank",
	"paypal": "paypal",
	"link": "link",
} as const
export type PaymentMethodsTypeOptions = typeof PaymentMethodsTypeOptions[keyof typeof PaymentMethodsTypeOptions]

export const PaymentMethodsBankFormatOptions = {
	"iban": "iban",
	"us": "us",
	"ca": "ca",
	"au": "au",
	"gb": "gb",
	"sg": "sg",
} as const
export type PaymentMethodsBankFormatOptions = typeof PaymentMethodsBankFormatOptions[keyof typeof PaymentMethodsBankFormatOptions]

export const PaymentMethodsAccountTypeOptions = {
	"checking": "checking",
	"savings": "savings",
} as const
export type PaymentMethodsAccountTypeOptions = typeof PaymentMethodsAccountTypeOptions[keyof typeof PaymentMethodsAccountTypeOptions]
export type PaymentMethodsRecord = {
	accountHolder?: string
	accountNumber?: string
	accountType?: PaymentMethodsAccountTypeOptions
	bankFormat?: PaymentMethodsBankFormatOptions
	bankName?: string
	bic?: string
	created: IsoAutoDateString
	iban?: string
	id: string
	institutionNumber?: string
	name: string
	paypal?: string
	routingCode?: string
	type: PaymentMethodsTypeOptions
	updated: IsoAutoDateString
	url?: string
	workspace: RecordIdString
}

export const RecurringInvoicesIntervalOptions = {
	"week": "week",
	"month": "month",
	"quarter": "quarter",
	"year": "year",
} as const
export type RecurringInvoicesIntervalOptions = typeof RecurringInvoicesIntervalOptions[keyof typeof RecurringInvoicesIntervalOptions]

export const RecurringInvoicesModeOptions = {
	"draft": "draft",
	"send": "send",
} as const
export type RecurringInvoicesModeOptions = typeof RecurringInvoicesModeOptions[keyof typeof RecurringInvoicesModeOptions]

export const RecurringInvoicesStatusOptions = {
	"active": "active",
	"paused": "paused",
	"ended": "ended",
} as const
export type RecurringInvoicesStatusOptions = typeof RecurringInvoicesStatusOptions[keyof typeof RecurringInvoicesStatusOptions]
export type RecurringInvoicesRecord<Tsnapshot = unknown> = {
	copyToMe?: boolean
	created: IsoAutoDateString
	createdBy?: RecordIdString
	emailMessage?: string
	emailSubject?: string
	endAfter?: number
	endDate?: IsoDateString
	id: string
	interval: RecurringInvoicesIntervalOptions
	lastError?: string
	lastRunAt?: IsoDateString
	mode: RecurringInvoicesModeOptions
	name?: string
	nextDate?: IsoDateString
	runs?: number
	sendCc?: string
	sendTo?: string
	snapshot?: null | Tsnapshot
	source?: RecordIdString
	startDate: IsoDateString
	status: RecurringInvoicesStatusOptions
	updated: IsoAutoDateString
	workspace: RecordIdString
}

export const SubscriptionsStatusOptions = {
	"active": "active",
	"trialing": "trialing",
	"past_due": "past_due",
	"canceled": "canceled",
	"incomplete": "incomplete",
	"incomplete_expired": "incomplete_expired",
	"unpaid": "unpaid",
	"paused": "paused",
} as const
export type SubscriptionsStatusOptions = typeof SubscriptionsStatusOptions[keyof typeof SubscriptionsStatusOptions]

export const SubscriptionsCancelReasonOptions = {
	"too_expensive": "too_expensive",
	"missing_features": "missing_features",
	"unused": "unused",
	"switched_service": "switched_service",
	"other": "other",
} as const
export type SubscriptionsCancelReasonOptions = typeof SubscriptionsCancelReasonOptions[keyof typeof SubscriptionsCancelReasonOptions]
export type SubscriptionsRecord = {
	cancelAtPeriodEnd?: boolean
	cancelComment?: string
	cancelReason?: SubscriptionsCancelReasonOptions
	created: IsoAutoDateString
	currentPeriodEnd?: IsoDateString
	id: string
	pausedUntil?: IsoDateString
	plan: string
	status: SubscriptionsStatusOptions
	stripeCustomerId?: string
	stripeSubscriptionId?: string
	updated: IsoAutoDateString
	user: RecordIdString
}

export const UsersLocaleOptions = {
	"en": "en",
	"de": "de",
	"fr": "fr",
	"es": "es",
	"it": "it",
	"nl": "nl",
	"pt": "pt",
	"pl": "pl",
	"sv": "sv",
	"da": "da",
	"nb": "nb",
	"fi": "fi",
	"is": "is",
	"cs": "cs",
	"tr": "tr",
	"ro": "ro",
	"hu": "hu",
	"et": "et",
	"lv": "lv",
	"lt": "lt",
} as const
export type UsersLocaleOptions = typeof UsersLocaleOptions[keyof typeof UsersLocaleOptions]

export const UsersHeardFromOptions = {
	"search": "search",
	"social": "social",
	"friend": "friend",
	"invoice": "invoice",
	"review": "review",
	"video": "video",
	"partner": "partner",
	"other": "other",
	"skipped": "skipped",
} as const
export type UsersHeardFromOptions = typeof UsersHeardFromOptions[keyof typeof UsersHeardFromOptions]
export type UsersRecord<Tattribution = unknown, Tlifecycle = unknown> = {
	attribution?: null | Tattribution
	avatar?: FileNameString
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	firstName?: string
	heardFrom?: UsersHeardFromOptions
	id: string
	lastName?: string
	lifecycle?: null | Tlifecycle
	lifecycleOptOut?: boolean
	locale?: UsersLocaleOptions
	name?: string
	password: string
	termsAcceptedAt?: IsoDateString
	termsVersion?: string
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
	workspaces?: RecordIdString[]
}

export const WorkspacesPlanOptions = {
	"free": "free",
	"starter": "starter",
	"pro": "pro",
} as const
export type WorkspacesPlanOptions = typeof WorkspacesPlanOptions[keyof typeof WorkspacesPlanOptions]
export type WorkspacesRecord = {
	companyAddressLine2?: string
	companyCity?: string
	companyContactName?: string
	companyCountry?: string
	companyDirectors?: string
	companyDisplayName?: string
	companyEmail?: string
	companyExtra?: string
	companyLogo?: FileNameString
	companyLogoWidth?: string
	companyName?: string
	companyPhone?: string
	companyPostalCode?: string
	companyRegister?: string
	companyReviewed?: boolean
	companyStreet?: string
	companyTaxNumber?: string
	companyVatId?: string
	companyWebsite?: string
	created: IsoAutoDateString
	defaultInvoice?: RecordIdString
	id: string
	name?: string
	owner?: RecordIdString
	plan?: WorkspacesPlanOptions
	updated: IsoAutoDateString
	users?: RecordIdString[]
}

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> = Required<AuthoriginsRecord> & BaseSystemFields<Texpand>
export type ExternalauthsResponse<Texpand = unknown> = Required<ExternalauthsRecord> & BaseSystemFields<Texpand>
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> & BaseSystemFields<Texpand>
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> & BaseSystemFields<Texpand>
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> & AuthSystemFields<Texpand>
export type AuditLogResponse<Tdetail = unknown, Texpand = unknown> = Required<AuditLogRecord<Tdetail>> & BaseSystemFields<Texpand>
export type ConnectedAppsResponse<Texpand = unknown> = Required<ConnectedAppsRecord> & BaseSystemFields<Texpand>
export type ConversationsResponse<Tmessages = unknown, Texpand = unknown> = Required<ConversationsRecord<Tmessages>> & BaseSystemFields<Texpand>
export type CustomersResponse<Texpand = unknown> = Required<CustomersRecord> & BaseSystemFields<Texpand>
export type InvitationsResponse<Texpand = unknown> = Required<InvitationsRecord> & BaseSystemFields<Texpand>
export type InvoicesResponse<Tbuyer = unknown, Titems = unknown, TpaymentDetails = unknown, Tsender = unknown, Texpand = unknown> = Required<InvoicesRecord<Tbuyer, Titems, TpaymentDetails, Tsender>> & BaseSystemFields<Texpand>
export type OauthClientsResponse<TredirectUris = unknown, Texpand = unknown> = Required<OauthClientsRecord<TredirectUris>> & BaseSystemFields<Texpand>
export type PaymentMethodsResponse<Texpand = unknown> = Required<PaymentMethodsRecord> & BaseSystemFields<Texpand>
export type RecurringInvoicesResponse<Tsnapshot = unknown, Texpand = unknown> = Required<RecurringInvoicesRecord<Tsnapshot>> & BaseSystemFields<Texpand>
export type SubscriptionsResponse<Texpand = unknown> = Required<SubscriptionsRecord> & BaseSystemFields<Texpand>
export type UsersResponse<Tattribution = unknown, Tlifecycle = unknown, Texpand = unknown> = Required<UsersRecord<Tattribution, Tlifecycle>> & AuthSystemFields<Texpand>
export type WorkspacesResponse<Texpand = unknown> = Required<WorkspacesRecord> & BaseSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	_authOrigins: AuthoriginsRecord
	_externalAuths: ExternalauthsRecord
	_mfas: MfasRecord
	_otps: OtpsRecord
	_superusers: SuperusersRecord
	audit_log: AuditLogRecord
	connected_apps: ConnectedAppsRecord
	conversations: ConversationsRecord
	customers: CustomersRecord
	invitations: InvitationsRecord
	invoices: InvoicesRecord
	oauth_clients: OauthClientsRecord
	payment_methods: PaymentMethodsRecord
	recurring_invoices: RecurringInvoicesRecord
	subscriptions: SubscriptionsRecord
	users: UsersRecord
	workspaces: WorkspacesRecord
}

export type CollectionResponses = {
	_authOrigins: AuthoriginsResponse
	_externalAuths: ExternalauthsResponse
	_mfas: MfasResponse
	_otps: OtpsResponse
	_superusers: SuperusersResponse
	audit_log: AuditLogResponse
	connected_apps: ConnectedAppsResponse
	conversations: ConversationsResponse
	customers: CustomersResponse
	invitations: InvitationsResponse
	invoices: InvoicesResponse
	oauth_clients: OauthClientsResponse
	payment_methods: PaymentMethodsResponse
	recurring_invoices: RecurringInvoicesResponse
	subscriptions: SubscriptionsResponse
	users: UsersResponse
	workspaces: WorkspacesResponse
}

// Utility types for create/update operations

type ProcessCreateAndUpdateFields<T> = Omit<{
	// Omit AutoDate fields
	[K in keyof T as Extract<T[K], IsoAutoDateString> extends never ? K : never]: 
		// Convert FileNameString to File
		T[K] extends infer U ? 
			U extends (FileNameString | FileNameString[]) ? 
				U extends any[] ? File[] : File 
			: U
		: never
}, 'id'>

// Create type for Auth collections
export type CreateAuth<T> = {
	id?: RecordIdString
	email: string
	emailVisibility?: boolean
	password: string
	passwordConfirm: string
	verified?: boolean
} & ProcessCreateAndUpdateFields<T>

// Create type for Base collections
export type CreateBase<T> = {
	id?: RecordIdString
} & ProcessCreateAndUpdateFields<T>

// Update type for Auth collections
export type UpdateAuth<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof AuthSystemFields>
> & {
	email?: string
	emailVisibility?: boolean
	oldPassword?: string
	password?: string
	passwordConfirm?: string
	verified?: boolean
}

// Update type for Base collections
export type UpdateBase<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof BaseSystemFields>
>

// Get the correct create type for any collection
export type Create<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? CreateAuth<CollectionRecords[T]>
		: CreateBase<CollectionRecords[T]>

// Get the correct update type for any collection
export type Update<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? UpdateAuth<CollectionRecords[T]>
		: UpdateBase<CollectionRecords[T]>

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = {
	collection<T extends keyof CollectionResponses>(
		idOrName: T
	): RecordService<CollectionResponses[T]>
} & PocketBase
